import "./App.css"
import Main from "./Components/Main.js"
import Footer from "./Components/Footer.js"

import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
      <div className="App">
        <Main />
        
        <Footer />
      </div>
  );
}

export default App;
